import { Endpoints } from "../constants/endpoint";

export const GetAllTranscriptions = async () => {
    try {
        const res = await fetch(Endpoints.transcriptions);
        console.log(res)
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const GetTranscriptionsPaginated = async ({
    page = 1,
    page_size = 20,
    search = "",
    date_from = "",
    date_to = "",
    stages = [],
    tag_ids = [],
} = {}) => {
    const params = new URLSearchParams({ page, page_size });
    if (search) params.append("search", search);
    if (date_from) params.append("date_from", date_from);
    if (date_to) params.append("date_to", date_to);
    if (Array.isArray(stages) && stages.length > 0) {
        params.append("stages", stages.join(","));
    }
    if (Array.isArray(tag_ids) && tag_ids.length > 0) {
        params.append("tag_ids", tag_ids.join(","));
    }
    const res = await fetch(`${Endpoints.transcriptions}paginated?${params}`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return await res.json();
}

export const CreateTranscription = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.transcriptions, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const EditTranscription = async (payload, id) => {
    const options = {
        method: 'PUT',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.transcriptions + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const DeleteTranscription = async (id) => {
    const options = {
        method: 'DELETE',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        }
    };
    try {
        const res = await fetch(Endpoints.transcriptions + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const GetAllUserTranscriptions = async () => {
    try {
        const res = await fetch(Endpoints.transcriptions);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const CreateUserTranscriptions = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.transcriptions, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const CreateUserTranscriptionsBulk = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.transcriptions + "bulk", options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const EditUserTranscriptions = async (payload, params) => {
    const options = {
        method: 'PUT',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.transcriptions + params, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const DeleteUserTranscription = async (id) => {
    const options = {
        method: 'DELETE',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        }
    };
    try {
        const res = await fetch(Endpoints.transcriptions + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}


export const GetFullTranscriptionById = async (id) => {
    try {
      const res = await fetch(Endpoints.transcriptions + id + "/full");
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data = await res.json();
      return data;
    } catch (err) {
      return err.message;
    }
  };

// NOTE: this one deliberately does NOT swallow errors into a return value.
// Returning `err.message` (a string) makes the calling thunk resolve as
// `fulfilled`, so the UI shows "Absatz geteilt" and refetches even though
// the split failed — the user sees a success toast and nothing changes.
// Let the error propagate so `splitParagraphAsync.rejected` fires.
export const SplitParagraph = async (payload) => {
    const res = await fetch(Endpoints.transcriptions + "split-paragraph", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        // Surface the backend's own message ("Split must leave words on
        // both sides", "split_word_id not found", ...) instead of a bare
        // status code — those are actionable for the user.
        let detail = "";
        try {
            const body = await res.json();
            detail = body?.error || "";
        } catch (_) {
            /* non-JSON error body — fall back to the status code */
        }
        throw new Error(
            detail || `Teilen fehlgeschlagen (HTTP ${res.status})`
        );
    }
    return await res.json();
};
  
export const GenerateDocFromFrontend = async (payload) => {
    try {
        const res = await fetch(Endpoints.transcriptions + "generate-doc-from-frontend", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(payload),
        });

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const blob = await res.blob();

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${payload.filename}.docx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return "Download started";
    } catch (err) {
        return err.message;
    }
};

export const exportSpeakerSection = async (payload) => {
    try {
        const res = await fetch(Endpoints.transcriptions + "export-sections-zip", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(payload),
        });

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const blob = await res.blob();

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${payload.filename}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return "Download started";
    } catch (err) {
        return err.message;
    }
};

export const rawTranscription = async (payload) => {
    try {
        const res = await fetch(Endpoints.transcriptions + "get_raw_transcription", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(payload),
        });

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const blob = await res.blob();

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${payload.filename}.json`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return "Download started";
    } catch (err) {
        return err.message;
    }
};

export const rtfDownload = async (id) => {
    try {
        const res = await fetch(Endpoints.transcriptions2 + "download_rtf/"+id, {
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8",
            }
        });

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const blob = await res.blob();

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${id}.rtf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return "Download started";
    } catch (err) {
        return err.message;
    }
};
